import React from 'react'
import Helmet from 'react-helmet'
import { mapProps } from 'recompose'

import {
  getSiteTitle
} from 'utils/selectors'

import Form from 'components/Form'

const Contact = ({ siteTitle }) => (
  <div className='max-width-2 mx-auto px2'>
    
    <Helmet title={`Contact us | ${siteTitle}`} />
    
    <p>
      Use the form below to get in touch with us about booking a skiing lesson.
    </p>
    
    <Form />
  </div>
)

const hoc = mapProps(({ data }) => ({
  siteTitle: getSiteTitle(data),
}))

export default hoc(Contact)

export const pageQuery = graphql`
  query ContactPageQuery {
    site {
      siteMetadata {
        title
        author
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/contact-us.js